import { useEffect, useRef, useState } from 'react';
import { IDLE_TIMEOUT_MS } from '../constants';

const IDLE_CHECK_INTERVAL_MS = 30 * 1000;
const ACTIVITY_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'];
const LISTENER_OPTIONS = { passive: true };

export const useIdleGate = (enabled) => {
  const [isIdle, setIsIdle] = useState(false);
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    if (!enabled || isIdle) return undefined;

    const recordActivity = () => {
      lastActivityRef.current = Date.now();
    };

    const checkForIdle = () => {
      if (Date.now() - lastActivityRef.current >= IDLE_TIMEOUT_MS) {
        setIsIdle(true);
        return true;
      }
      return false;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;
      if (!checkForIdle()) recordActivity();
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, recordActivity, LISTENER_OPTIONS);
    });
    document.addEventListener('visibilitychange', handleVisibilityChange, LISTENER_OPTIONS);

    const intervalId = window.setInterval(checkForIdle, IDLE_CHECK_INTERVAL_MS);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, recordActivity, LISTENER_OPTIONS);
      });
      document.removeEventListener('visibilitychange', handleVisibilityChange, LISTENER_OPTIONS);
      window.clearInterval(intervalId);
    };
  }, [enabled, isIdle]);

  return enabled && isIdle;
};
